// extracted by mini-css-extract-plugin
module.exports = {"gif":"section-pistol-module--gif--3cmw0"};